import { Button, Tooltip, Spinner } from '@chakra-ui/react';
import React from 'react';

import { LenderShareReportFragmentGQLType } from '../../../../types/dashboard-core-gqlTypes.generated.d';
import { Icon } from 'packages/common-frontend/components/icons';
import { useGetLenderShareReportsQuery } from 'packages/loans/requests/loans.gql.generated';
import { useDownloadReportUrl } from 'packages/reporting/hooks/useDownloadReportUrl';

const DownloadButtonBody = ({
  report,
}: {
  report: LenderShareReportFragmentGQLType;
}) => {
  const { getReportDownloadUrl, isLoading } = useDownloadReportUrl(report);

  return (
    <Tooltip label="Download funding notice">
      <Button
        variant="v2-ghost"
        onClick={getReportDownloadUrl}
        isLoading={isLoading}
      >
        <Icon icon="arrow-down-to-bracket" />
      </Button>
    </Tooltip>
  );
};

export const DownloadLiveFundingNoticeButton = ({
  lenderShareId,
  fundingRequestComponentId,
}: {
  lenderShareId: string;
  fundingRequestComponentId: string;
}) => {
  const {
    data: lenderShareReportsDownloadUrlsData,
    loading: isLenderShareReportsDownloadUrlsLoading,
  } = useGetLenderShareReportsQuery({
    fetchPolicy: 'network-only',
    variables: { lenderShareId, fundingRequestComponentId },
  });

  if (
    isLenderShareReportsDownloadUrlsLoading ||
    !lenderShareReportsDownloadUrlsData
  ) {
    return <Spinner />;
  }

  const fundingNoticeReport = lenderShareReportsDownloadUrlsData.reports.find(
    (report) => report.reportType === 'fundingNotice',
  );

  if (!fundingNoticeReport) {
    return (
      <Tooltip label="No funding notice found" placement="left">
        <Button variant="v2-ghost" isDisabled>
          <Icon icon="arrow-down-to-bracket" />
        </Button>
      </Tooltip>
    );
  }

  return <DownloadButtonBody report={fundingNoticeReport} />;
};
